import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "confirmation-popover",
  templateUrl: "./confirmation-popover.component.html",
})
export class ConfirmationPopover {

  @Input()
  public question: string = "Are you sure?";

  @Input()
  public placement: string = "left";

  @Input()
  public label: string = "";

  @Input()
  public className: string = "";
  @Input() public additionalInfo: string = "";

  @Output()
  public onConfirmed: EventEmitter<any> = new EventEmitter();

  public onShown(e: any) {
    console.log(e);

  }
}
